import { getToken } from "../utils/utilFunctions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const headers = () => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${getToken()}`,
});

export async function getNotifications(callback) {
    const res = await fetch(`${API_URL}/api/notifications`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    callback(data.data);
    return data.data;
}

export async function markNotificationAsRead(notificationId, doneCallback) {
    try {
        const res = await fetch(`${API_URL}/api/notifications/${notificationId}/read`, {
            method: "PATCH",
            headers: headers(),
        });

        const data = await res.json();

        if (!res.ok || !data.success) throw new Error(data.message);

        if (doneCallback)  
            doneCallback(data.data);
        return data.data;
    } catch (err) {
        console.error("Error marking notification as read:", err);
        throw err;
    }
}